import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appThreeDigitDecimaNumber]'
})
export class ThreeDigitDecimaNumberDirective {
  // private regex: RegExp = new RegExp(/^\d*\.?\d{0,3}$/g);
  private regex = new RegExp(/^\d{0,5}(\.\d{0,3})?$/);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // console.log(this.el.nativeElement.value);
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
